'use client';

import type { ReactNode } from 'react';
import { useIsMobileAppArticle } from '@/app_lib/hooks/useIsMobileAppArticle';

export const HideOnMobileAppArticle = ({ children }: { children: ReactNode }) => {
  const isMobileAppArticle = useIsMobileAppArticle();
  if (isMobileAppArticle) {
    return null;
  }
  return children;
};
